/* @flow */
import React from 'react';
import cx from 'classnames';
import ReactSelect from 'react-select';
import 'react-select/dist/react-select.css';

import s from './Select.styl';

/**
 * This was created to add valueLink functionality and any other custom logic we
 * need.
 *
 * NOTE: This used to use the pure render mixin.
 */

type SelectProps = {
  value?: any,
  className?: string,
  onChange?: Function,
  onMount?: Function,
  valueLink?: {
    value: string,
    requestChange: Function,
  },
  meta?: Object,
};

export class Select extends React.Component {
  props: SelectProps;

  componentDidMount() {
    if (this.props.onMount) {
      this.props.onMount();
    }
  }

  render() {
    let { className, valueLink, onChange, value, meta, ...props } = this.props; // eslint-disable-line prefer-const
    value = valueLink ? valueLink.value : value;
    onChange = valueLink ? valueLink.requestChange : onChange;
    return (
      <div data-cy={'react-select-containing-div'}>
        <ReactSelect
          className={cx(s.Select, className)}
          value={value}
          onChange={onChange}
          {...props} />
        {meta && (meta.touched && meta.error && <span className={cx(s.error, 'error')}>{meta.error}</span>)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/Select.js